import { createUniqueId, mergeObjects } from './helper'
import RACES from '../constants/RACES'
import itemHelper from './itemHelper'

const { getItemData } = itemHelper

const createBaseUnit = (faction, type, name, gender, mods) => ({
    ID: `unit_${createUniqueId()}`,
    name,
    type,
    gender,
    faction,
    mods,
})

const getValueForTier = (currentTier, array) => array.map((entry) => {
    const { category, element, tier } = entry
    return { category, element, value: tier[currentTier] }
})

const getEquippedItemEffects = (effects, item) => {
    const {
        tier, damage, protection, stats,
    } = item
    if (damage) { effects.damage.push(getValueForTier(tier, damage)) }
    if (protection) { effects.protection.push(getValueForTier(tier, protection)) }
    if (stats) { effects.stats.push(stats) }
    return effects
}

const calculateEffectiveData = (baseStats, mods = {}, equipment) => {
    const { stats: modStats = {} } = mods
    const moddedStats = modStats.length ? mergeObjects(baseStats, modStats) : baseStats

    if (!equipment || equipment.length === 0) {
        return { moddedStats }
    }

    const items = equipment.map(item => getItemData(item))
    const equippedItemEffects = items.reduce(
        getEquippedItemEffects,
        { damage: [], protection: [], stats: [] }
    )

    const mergeEffects = (accumulator, effect) => (mergeObjects(accumulator, effect))

    const offenseEffects = equippedItemEffects.damage.reduce(mergeEffects, {})
    const defenseEffects = equippedItemEffects.protection.reduce(mergeEffects, {})
    const statsEffects = equippedItemEffects.stats.reduce(mergeEffects, {})

    const equippedStats = mergeObjects(moddedStats, statsEffects)

    return {
        moddedStats,
        equippedStats,
        offenseEffects,
        defenseEffects,
    }
}

const getUnitData = (baseUnit) => {
    const {
        type, gender, mods, equipment,
    } = baseUnit
    const race = RACES[type].name
    const avatar = RACES[type].avatar[gender]
    const baseStats = RACES[type].stats
    const {
        moddedStats,
        equippedStats,
        offenseEffects,
        defenseEffects,
    } = calculateEffectiveData(baseStats, mods, equipment)
    const timeframe = (mods && mods.timeframe) || moddedStats.rate

    return ({
        ...baseUnit,
        avatar,
        race,
        stats: equippedStats || moddedStats,
        baseStats: moddedStats,
        status: RACES[type].status || {},
        offenseEffects,
        defenseEffects,
        timeframe,
        initialTimeframe: timeframe,
    })
}

export default {
    createBaseUnit,
    getUnitData,
}
